export class WorkflowType {
  public static readonly SIGNATURE = 1;
  public static readonly SIGNATURE_AND_NOTIFICATION = 2;
  public static readonly SIGNATURE_AND_NOTIFICATION_WITH_TEMPLATE = 3;
  public static readonly UPLOAD_TO_IOFESIGN = 4;
  public static readonly NOTCER = 5;
  // public static readonly UPLOAD_TO_IOFESIGN_FOR_ELECTRONIC_NOTIFICATION = 5;
  // public static readonly UPLOAD_TO_IOFESIGN_FOR_SENDING_TO_EMAIL = 6;
}
